import { FC } from "react";
import { Box, Button, TextField } from "@mui/material";
import { AppModal } from "../../../../components/ui";
import { VehicleViewModel } from "../../../../models/vehicles.model";

type Props = {
    open: boolean;
    onClose: () => void;
    isEditing: boolean;
    btnSaveDisabled: boolean;
    formik: any;
    vehicleViewModel: VehicleViewModel;
    setVehicleViewModel: (model: VehicleViewModel) => void;
};

/** Modal de cadastro/edição de veículo (base farmacêutica). */
const VehicleFormModal: FC<Props> = ({ open, onClose, isEditing, btnSaveDisabled, formik, vehicleViewModel, setVehicleViewModel }) => {
    const { errors, touched, handleSubmit, getFieldProps } = formik;

    return (
        <AppModal
            open={open}
            onClose={onClose}
            kicker={isEditing ? "Editar" : "Cadastrar"}
            title={isEditing ? "Editar veículo" : "Novo veículo"}
            maxWidth={720}
            footer={
                <>
                    <Button variant="outlined" onClick={onClose} sx={{ height: 40, borderRadius: "10px" }}>
                        Cancelar
                    </Button>
                    <Button variant="contained" disabled={btnSaveDisabled} onClick={() => handleSubmit()} sx={{ height: 40, borderRadius: "10px" }}>
                        Salvar
                    </Button>
                </>
            }
        >
            <form noValidate onSubmit={handleSubmit}>
                <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" }, gap: 2.5 }}>
                    <TextField
                        label="Nome do veículo"
                        fullWidth
                        {...getFieldProps("name")}
                        value={vehicleViewModel.name}
                        onChange={(e) => {
                            vehicleViewModel.name = e.target.value;
                            setVehicleViewModel({ ...vehicleViewModel });
                        }}
                        error={Boolean(touched.name && errors.name)}
                        helperText={touched.name && errors.name}
                    />

                    <TextField
                        label="PH de estabilidade"
                        fullWidth
                        {...getFieldProps("PH")}
                        value={vehicleViewModel.PH}
                        onChange={(e) => {
                            vehicleViewModel.PH = e.target.value;
                            setVehicleViewModel({ ...vehicleViewModel });
                        }}
                        error={Boolean(touched.PH && errors.PH)}
                        helperText={touched.PH && errors.PH}
                    />

                    <TextField
                        label="Dosagem mínima"
                        fullWidth
                        type="number"
                        inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                        {...getFieldProps("minimum")}
                        value={vehicleViewModel.minimum}
                        onChange={(e) => {
                            vehicleViewModel.minimum = e.target.value;
                            setVehicleViewModel({ ...vehicleViewModel });
                        }}
                        error={Boolean(touched.minimum && errors.minimum)}
                        helperText={touched.minimum && errors.minimum}
                    />

                    <TextField
                        label="Dosagem máxima"
                        fullWidth
                        type="number"
                        inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                        {...getFieldProps("maximum")}
                        value={vehicleViewModel.maximum}
                        onChange={(e) => {
                            vehicleViewModel.maximum = e.target.value;
                            setVehicleViewModel({ ...vehicleViewModel });
                        }}
                        error={Boolean(touched.maximum && errors.maximum)}
                        helperText={touched.maximum && errors.maximum}
                    />

                    <TextField
                        label="Incompatibilidade"
                        fullWidth
                        {...getFieldProps("incompatibility")}
                        value={vehicleViewModel.incompatibility}
                        onChange={(e) => {
                            vehicleViewModel.incompatibility = e.target.value;
                            setVehicleViewModel({ ...vehicleViewModel });
                        }}
                        error={Boolean(touched.incompatibility && errors.incompatibility)}
                        helperText={touched.incompatibility && errors.incompatibility}
                    />

                    <TextField
                        label="Fonte"
                        fullWidth
                        {...getFieldProps("source")}
                        value={vehicleViewModel.source}
                        onChange={(e) => {
                            vehicleViewModel.source = e.target.value;
                            setVehicleViewModel({ ...vehicleViewModel });
                        }}
                        error={Boolean(touched.source && errors.source)}
                        helperText={touched.source && errors.source}
                    />

                    <TextField
                        label="Mecanismo de ação"
                        fullWidth
                        multiline
                        rows={4}
                        {...getFieldProps("mechanism_action")}
                        value={vehicleViewModel.mechanism_action}
                        onChange={(e) => {
                            vehicleViewModel.mechanism_action = e.target.value;
                            setVehicleViewModel({ ...vehicleViewModel });
                        }}
                        error={Boolean(touched.mechanism_action && errors.mechanism_action)}
                        helperText={touched.mechanism_action && errors.mechanism_action}
                        sx={{ gridColumn: { sm: "1 / -1" } }}
                    />

                    <TextField
                        label="Descrição"
                        fullWidth
                        multiline
                        rows={4}
                        {...getFieldProps("description")}
                        value={vehicleViewModel.description}
                        onChange={(e) => {
                            vehicleViewModel.description = e.target.value;
                            setVehicleViewModel({ ...vehicleViewModel });
                        }}
                        error={Boolean(touched.description && errors.description)}
                        helperText={touched.description && errors.description}
                        sx={{ gridColumn: { sm: "1 / -1" } }}
                    />
                </Box>
            </form>
        </AppModal>
    );
};

export default VehicleFormModal;
